<template>
  <div>
    <div class="pb-20">
      <el-button type="primary" @click="vue_pop_show_hide(true)">添加管理员</el-button>
    </div>
    <el-table :data="list" border stripe>
      <el-table-column label="ID" prop="id" width="80px"></el-table-column>
      <el-table-column label="登陆账号" prop="username"></el-table-column>
      <el-table-column label="绑定微信用户">
        <template v-slot="scope">
          <div class="wx-user" v-if="scope.row.user">
            <div class="avatarurl" :style="{ backgroundImage:'url('+scope.row.user.avatarurl+')' }"></div>
            <div class="nickname">{{scope.row.user.nickname}}</div>
          </div>
          <div class="wx-user" v-if="!scope.row.user">
            暂无绑定用户
          </div>
        </template>
      </el-table-column>
      <el-table-column label="真实姓名" prop="realname" ></el-table-column>
      <el-table-column label="手机号码" prop="mobile"></el-table-column>
<!--      <el-table-column label="接收信息" prop="is_message">
        <template v-slot="scope">
          <el-tag type="success" v-if="scope.row.is_message == 1">接收</el-tag>
          <el-tag type="info" v-if="scope.row.is_message == 0">不接收</el-tag>
        </template>
      </el-table-column>-->
      <el-table-column label="超级管理员" prop="is_admin">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.is_admin==1" size="small">超级管理员</el-tag>
          <el-tag type="info" v-if="scope.row.is_admin == 0" size="small">非超级管理员</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="addtime_format"></el-table-column>
      <el-table-column label="最后登陆" prop="lasttime_format"></el-table-column>
      <el-table-column label="操作" width="220px">
        <template v-slot="scope">
          <el-button type="primary" @click="admin_edit(scope.row.id)" size="small">编辑</el-button>
          <el-popconfirm title="确定禁止此用户登陆？" @confirm="admin_login(scope.row.id,'un')" v-if="scope.row.is_login==0">
            <el-button class="ml-10" type="danger" size="small" slot="reference">禁止</el-button>
          </el-popconfirm>
          <el-popconfirm title="确定放行此用户登陆？" @confirm="admin_login(scope.row.id,'is')" v-if="scope.row.is_login==1">
            <el-button class="ml-10" type="success" size="small" slot="reference">通行</el-button>
          </el-popconfirm>

        </template>
      </el-table-column>
    </el-table>
    <LayerPop title="添加/编辑管理员" @close="vue_pop_show_hide" v-if="is_pop">
      <AdminEdit :aid="aid" @submit="admin_submit"></AdminEdit>
    </LayerPop>
  </div>
</template>

<script>
import AdminEdit from "@/components/admin-add-edit";
import LayerPop from "@/components/layer-pop";
export default {
name: "admin",
  components:{
    AdminEdit,LayerPop
  },
  data(){
    return{
      list:[],
      is_pop : false,
      aid:0,
    }
  },
  mounted:async function(){
    try{
      this.$_showLoading();
      let res = await this.$_api.admin('get_list');
      console.log(res);
      if (res.errcode == 0){
        this.list = res.list;
      }
      this.$_hideLoading();
      this.$store.state.menu =111;
    }catch (e){
      console.log(e);
      return false;
    }
  },
  methods:{
    admin_edit : function  (id){
      this.aid = id;
      this.is_pop = true;
    },
    admin_submit : async function  (){
      try{
        this.aid = 0;
        this.is_pop = false;
        this.$_showLoading();
        let res = await this.$_api.admin('get_list');
        if (res.errcode == 0){
          this.list = res.list;
        }
        this.$_hideLoading();
      }catch (e){
        console.log(e);
        return false;
      }
    },
  }
}
</script>

<style scoped>
.wx-user { display: flex; height: 40px; overflow-x: hidden; vertical-align: middle; line-height: 40px;}
.avatarurl { width: 40px; height: 40px; border-radius: 20px; overflow-x: hidden; background: #f2f2f2 no-repeat center;
  background-size: cover; }
.nickname { padding-left: 15px; font-size: 14px; line-height: 40px;flex: 1 }
</style>